import { Fragment } from "react";
import { string, array } from "prop-types";

const propTypes = {
  eyebrow: string,
  title: string.isRequired,
  authors: array,
  authorLabel: string,
  text: string.isRequired,
  links: array,
};

const QaWildcard = (props) => {
  const {
    eyebrow,
    title,
    authors,
    text,
    links,
    authorLabel,
    backLink = "#cvf",
  } = props;

  return (
    <section className="qa-wildcard container--has-background">
      <div>
        <a className="qa-wildcard__back-link" href={backLink}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-arrow-left"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          <span>Back</span>
        </a>
      </div>
      {eyebrow && <div className="qa-wildcard__eyebrow">{eyebrow}</div>}
      <h2 className="qa-wildcard__title">{title}</h2>
      {authors && authors.length > 0 && (
        <div className="qa-wildcard__subtitle">
          <span className="qa-wildcard__author-label">{authorLabel}</span>
          <span className="qa-wildcard__authors">{authors.join(", ")}</span>
        </div>
      )}
      <div
        className="rich-text qa-wildcard__text"
        dangerouslySetInnerHTML={{ __html: text }}
      />
      <div>
        {links && (
          <Fragment>
            <div className="qa-wildcard__related-links-title">Related:</div>
            <ul className="qa-wildcard__related-links">
              {links.map((link, index) => {
                return (
                  <li key={index} className="qa-wildcard__list-item">
                    <a href={link.href}>{link.label}</a>
                  </li>
                );
              })}
            </ul>
          </Fragment>
        )}
      </div>
    </section>
  );
};

QaWildcard.propTypes = propTypes;
export default QaWildcard;
